import React from 'react';

import { HubPage } from 'components/buyer/hub/HubPage';
import { getBuyerDashboardLayout } from 'components/shared/AuthenticatedDashboardLayout';
import Head from 'next/head';

import type { NextPageWithLayout } from './_app';

const DashboardPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>My Dashboard | Opendoor</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <HubPage />
    </>
  );
};

const DashboardPageWithLayout = DashboardPage as NextPageWithLayout & { theme?: string };
DashboardPageWithLayout.getLayout = getBuyerDashboardLayout;
DashboardPageWithLayout.theme = 'novo';

export default DashboardPageWithLayout;
